/* eslint-disable no-undef */
import * as amplitude from '@amplitude/analytics-browser';
import { isEmpty } from 'lodash/fp';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useLoadAmplitude = (userId) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  const { currentUser } = useSelector((state) => ({
    currentUser: state.profileReducer.userProfile,
  }));
  useEffect(() => {
    // use useId if currentUser is empty && userId is not empty
    if (
      (!isEmpty(currentUser) || (isEmpty(currentUser) && userId)) &&
      process.env.AMPLITUDE_API_KEY &&
      !hasLoaded
    ) {
      amplitude.init(
        process.env.AMPLITUDE_API_KEY,
        !isEmpty(currentUser) ? currentUser.id : userId,
        {
          defaultTracking: {
            sessions: true,
            pageViews: true,
            formInteractions: true,
            fileDownloads: true,
          },
          minIdLength: 1,
        }
      );
      setHasLoaded(true);
    }
  }, [currentUser, hasLoaded, userId]);
};

export default useLoadAmplitude;
